module.exports = __webpack_public_path__ + "static/img/Galaxy_watch_LTE.63bea2b8.jpg";